// extracted by mini-css-extract-plugin
module.exports = {"operaBox":"index_operaBox__1jFzr","fatherBox":"index_fatherBox__3hYWM","childBox":"index_childBox__3QvXe","select":"index_select__FSNyy"};